<template>
  <div class="invoiced-count">
    <span class="count">{{ value || 0 }}</span>
    <span class="fill" :style="style"></span>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Number,
      required: false,
    },
    total: {
      type: Number,
      required: false,
    },
  },
  computed: {
    style () {
      if (!this.total) {
        return {
          width: '100%',
        };
      }

      return {
        width: Math.round((100 - (this.value || 0) / this.total * 100)) + '%',
      };
    },
  },
};

</script>

<style lang="scss">

.invoiced-count {
  background: #494e50;
  border-radius: 3px;
  color: #fff;
  display: inline-block;
  font-weight: bold;
  overflow: hidden;
  padding: 3px 6px;
  position: relative;

  .count {
    position: relative;
    z-index: 2;
  }

  .fill {
    background: $primary;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
  }
}

</style>
